import { render, staticRenderFns } from "./CreateUnitDialog.vue?vue&type=template&id=bd4e63de&scoped=true&"
import script from "./CreateUnitDialog.vue?vue&type=script&lang=js&"
export * from "./CreateUnitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e63de",
  null
  
)

export default component.exports